import React, { Component } from 'react';
import select_data from "../data/select_research.json";
import './Projects.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeartPulse, faBook, faUtensils, faPaw, faStethoscope, faMicrophone, faImage, faWaveSquare } from '@fortawesome/free-solid-svg-icons';

const projectIcons = {
  'Pronunciation': faMicrophone,
  'SketchMirror': faImage,
  'Whisper': faWaveSquare,
  'RecovR': faHeartPulse,
  'BookTrack': faBook,
  'Melting Pot': faUtensils,
  'Pet Patrol': faPaw,
  'Little Star': faStethoscope,
};

function getProjectIcon(title) {
  const key = Object.keys(projectIcons).find(k => title.includes(k));
  return key ? projectIcons[key] : null;
}

class Projects extends Component {

  render() {
    return (
      <div className="ResearchContainer">
        <div className="section-header">
          <h2 className="Title_research">Projects</h2>
        </div>
        
        <div className="papers-container">
          {select_data.Research.map((project, index) => { 
            return (
              <div key={index} className="paper-container">
                <span className="PaperTitle">
                  {getProjectIcon(project.Title) && (
                    <FontAwesomeIcon icon={getProjectIcon(project.Title)} className="project-icon" />
                  )}
                  {project.Title}
                </span>
                {project.Date && <span className="ProjectDate">{project.Date}</span>}
                <span className="Description">{project.Description}</span>
                <div className="details-container">
                  {project.Details.map((Details, idx) => {
                    return (
                      <a 
                        key={`remote-${idx}`}
                        className="Details" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        href={Details.detail}
                      >
                        {Details.detailType}
                      </a>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
} 

export default Projects;